/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Purchasecta1Inputs */

const ja_playdata_pricing_purchasecta1 = /** @type {(inputs: Playdata_Pricing_Purchasecta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入のお問い合わせ`)
};

const en_playdata_pricing_purchasecta1 = /** @type {(inputs: Playdata_Pricing_Purchasecta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us to purchase`)
};

/**
* | output |
* | --- |
* | "Contact us to purchase" |
*
* @param {Playdata_Pricing_Purchasecta1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_pricing_purchasecta1 = /** @type {((inputs?: Playdata_Pricing_Purchasecta1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Purchasecta1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_purchasecta1(inputs)
	return en_playdata_pricing_purchasecta1(inputs)
});
export { playdata_pricing_purchasecta1 as "playdata_pricing_purchaseCta" }